module.exports = __webpack_public_path__ + "static/img/step3.c41a3ab2.png";